<div class="block-ui-wrapper d-block position-relative">
  <div class="block-ui-spinner">
    <div class="loader">
    </div>
    <div class="message"> Redirecting </div>
  </div>
</div>